import { Box, Container, ContainerProps, PaperProps, useTheme } from '@mui/material';
import { alpha } from '@mui/material/styles';
import { t } from 'i18next';
import React from 'react';

import Button from '../././Button';

type PaperAndContainerProps = Partial<ContainerProps> & Partial<PaperProps>;

interface DialogContainerProps extends PaperAndContainerProps {
  close: () => void;
}
const backdropAlphaCoefficient = 0.9;

export const DialogContainer: React.FC<DialogContainerProps> = ({ children, close, ...props }) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        margin: 'auto',
        width: `min(100%, ${theme.breakpoints.values[props.maxWidth || 'lg']}px)`,
      }}
    >
      <Box
        sx={{
          backdropFilter: 'blur(7px)',
          backgroundColor: alpha(theme.palette.background.paper, backdropAlphaCoefficient),
          height: '3rem',
          left: 0,
          position: 'fixed',
          top: '0px',
          width: '100%',
          zIndex: 1000,
        }}
      >
        <Container
          maxWidth={props.maxWidth}
          sx={{
            height: '100%',
          }}
        >
          <Box
            component={Button}
            icon="long-arrow-left"
            sx={{
              alignItems: 'center',
              color: theme.palette.text.primary,
              display: 'flex',
              height: '100%',
            }}
            variant="text"
            onClick={close}
          >
            {t('dialog.back')}
          </Box>
        </Container>
      </Box>
      <Box
        sx={{
          padding: '0.5625rem',
        }}
      >
        {children}
      </Box>
    </Box>
  );
};
